var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Original"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0003 1.5C18 1.5 19.8886 6.12046 19.7537 10.4962L19.7086 11.9568C19.6171 14.925 17.6919 17.6532 14.7759 18.2148C12.8016 18.5951 11.1989 18.5951 9.22465 18.2148C6.30862 17.6532 4.38349 14.925 4.29194 11.9568L4.2469 10.4962C4.11194 6.12046 6.00056 1.5 12.0003 1.5ZM12.0003 1.5C12.0003 7 9.50028 9.03425 4.50028 8.5M12.0003 1.5C12.0003 7 14.5003 9.03425 19.5003 8.5M15.0003 11.5H15.0103M9.00028 11.5H9.01028M10.5003 14.5C11.2503 15.5 12.7503 15.5 13.5003 14.5M19.5003 8.52653C24.0852 7.9922 24.0877 13.9889 19.9665 13.9982M4.50028 8.52589C-0.0846751 7.99156 -0.0871449 13.9883 4.03411 13.9975",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChild);
export default __webpack_public_path__ + "static/media/icon-child.dfcf47bff55257d4ca0eeef4f57bc6a5.svg";
export { ForwardRef as ReactComponent };